export default "https://mern-mmc-social.herokuapp.com";
